if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        const isBundlePage = document.querySelector('custom-switch');
        if (isBundlePage) {
          this.form.addEventListener('submit', this.handleBundleSubmit.bind(this));
        } else if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    handleBundleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;
      evt.preventDefault();

      const GroupID = Date.now().toString();
      const form = evt.target.closest('form');
      let sections = 'cart-icon-bubble';
      let objectsArray = [];
      let properties = {};
      let hasErrors = false;

      const quantity = parseInt(form.querySelector("input[name='quantity']").value) || 1;
      const mainProductId = parseInt(document.querySelector('custom-switch').getAttribute('id'));

      const mainProduct = {
        id: mainProductId,
        quantity: quantity,
        properties: properties
      };

      const gangWrapper = document.querySelector('.first_step');
      let no_of_gang = 0;
      if (gangWrapper) {
        const sizeInput = gangWrapper.querySelector('.size_flex.active input:checked');
        if (sizeInput) no_of_gang = parseInt(sizeInput.dataset.gang) || 0;
      }

      const colorVariants = document.querySelector('.color_switch_variant.active');
      if (colorVariants) {
        const selectedColor = colorVariants.querySelector('input:checked:not(:disabled)');
        if (selectedColor) {
          const selectedPlateId = selectedColor.getAttribute('data-id');

          objectsArray.push({
            id: parseInt(selectedPlateId),
            quantity: quantity,
            properties: { Group_ID: GroupID }
          });

          const bundlePriceEl = document.querySelector('#bundle-price');
          if (bundlePriceEl) properties['Bundle Price'] = bundlePriceEl.value || '';

          properties['Plate Color'] = selectedColor.closest('.item_col').dataset.prop || '';
          properties['Plate Size'] = `${no_of_gang + 1} Gang`;

          const warningEl = colorVariants.closest('.second_step');
          if (warningEl) {
            const w = warningEl.querySelector('.warning_text');
            if (w) w.remove();
          }
        } else {
          hasErrors = true;
          if (window.BYOConfigurator) {
            window.BYOConfigurator.showError('Please select a plate color.');
            window.BYOConfigurator.goToStep('color');
          }
        }
      }

      const moduleWrapper = document.querySelector('.modules');
      if (moduleWrapper) {
        const activeModules = moduleWrapper.querySelectorAll('.hide_module.active');
        activeModules.forEach((moduleItem, index) => {
          const ind = index + 1;
          const selectedInput = moduleItem.querySelector('input:checked:not(:disabled)');
          if (selectedInput) {
            objectsArray.push({
              id: parseInt(selectedInput.dataset.id),
              quantity: quantity,
              properties: { Group_ID: GroupID }
            });
            properties[`Module ${ind}`] = `${selectedInput.dataset.prop} / ${selectedInput.dataset.sku}`;
          } else {
            hasErrors = true;
          }
        });

        if (hasErrors && window.BYOConfigurator) {
          window.BYOConfigurator.showError('Please select all modules before adding to cart.');
          if (!colorVariants || colorVariants.querySelector('input:checked:not(:disabled)')) {
            window.BYOConfigurator.goToStep('modules');
          }
        }
      }

      if (hasErrors) {
        this.submitBtn.setAttribute('aria-disabled', 'false');
        this.submitBtn.classList.remove('is-loading');
        return;
      }

      if (window.BYOConfigurator) window.BYOConfigurator.hideError();

      objectsArray.unshift(mainProduct);

      const formData = { items: objectsArray };

      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }
      formData.sections_url = window.location.pathname;
      formData.sections = sections;

      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
        .then(response => {
          if (!response.ok) {
            this.submitBtn.setAttribute('aria-disabled', 'false');
            this.submitBtn.classList.remove('is-loading');
            return response.json().then(err => {
              throw new Error(err.message || 'Something went wrong');
            });
          }
          return response.json();
        })
        .then(state => {
          this.submitBtn.setAttribute('aria-disabled', 'false');
          this.submitBtn.classList.remove('is-loading');
          const cart = document.querySelector('cart-drawer');
          if (cart) {
            cart.renderContents(state, true);
          }
        })
        .catch(error => {
          console.error('Bundle add to cart error:', error);
          this.submitBtn.setAttribute('aria-disabled', 'false');
          this.submitBtn.classList.remove('is-loading');
        });
    }

    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      let sections = 'cart-icon-bubble';
      const formData = new FormData(this.form);

      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }
      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {

  // 1. Add to cart (only 1 fetch!)
  const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
  const data = await response.json();

  if (!response.ok) {
    let error = typeof data.description === 'string' ? data.description : data.message;
    if (data.errors && typeof data.errors === 'object') {
      error = Object.entries(data.errors).map(item => item[1].join(', '));
    }
    this.setErrorMsgState(error);
    throw new Error(response.status);
  }

  // Update cart quantity bubble instantly
  ProductForm.updateCartIcon(data);

  // Quick Add success message
  const quickAddDrawer = this.closest('quick-add-drawer');
  if (quickAddDrawer) quickAddDrawer.addedToCart();

  // 2. Update cart drawer
  setTimeout(() => {
    if (this.cartDrawer) {
      this.cartDrawer.renderContents(data, !quickAddDrawer && theme.settings.afterAtc === 'drawer');
    }
  }, 300);

   setTimeout(() => {
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);

  // Dispatch event
  this.dispatchEvent(new CustomEvent('on:cart:add', {
    bubbles: true,
    detail: {
      cart: data,
      variantId: data.variant_id
    }
  }));

} catch (error) {
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}

